import React from 'react';
import { Lock, LogOut, MoreVertical, UserX } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";

interface UserActionsDropdownProps {
  user: {
    id: number;
    username: string;
  };
  onResetPassword: (id: number, username: string) => void;
  onForceLogout?: (id: number) => void;
  onRemove?: (userId: number, username: string) => void;
  onDelete?: (userId: number, username: string) => void;
  showForceLogout?: boolean;
}

export function UserActionsDropdown({
  user,
  onResetPassword,
  onForceLogout,
  onRemove,
  onDelete,
  showForceLogout = false,
}: UserActionsDropdownProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon">
          <MoreVertical className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuItem onClick={() => onResetPassword(user.id, user.username)}>
          <Lock className="mr-2 h-4 w-4" />
          <span>Reset Password</span>
        </DropdownMenuItem>
        
        {showForceLogout && onForceLogout && (
          <DropdownMenuItem onClick={() => onForceLogout(user.id)}>
            <LogOut className="mr-2 h-4 w-4" />
            <span>Force Logout</span>
          </DropdownMenuItem>
        )}
        
        {onRemove && (
          <DropdownMenuItem 
            className="text-destructive focus:text-destructive" 
            onClick={() => onRemove(user.id, user.username)}
          >
            <UserX className="mr-2 h-4 w-4" />
            <span>Remove</span>
          </DropdownMenuItem>
        )}
        
        {onDelete && (
          <DropdownMenuItem 
            className="text-destructive focus:text-destructive" 
            onClick={() => onDelete(user.id, user.username)}
          >
            <UserX className="mr-2 h-4 w-4" />
            <span>Delete</span>
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}